module.exports = __webpack_public_path__ + "img/20.7da42829.jpg";